export function validHourHHmm(hour: string): boolean {
  const pattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  if (!hour) {
    return false;
  }
  return pattern.test(hour);
}
